import { useCallback, useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useDashboardFiles(section, start, total) {
  const [list, setList] = useState({ ficheros: [], total: 0 });

  const getData = useCallback(async () => {
    const response = await post(
      "support-extra/gestionDocumental/ListarFicherosGD.php",
      {
        token: userData.token,
        seccion: section,
        start,
        total,
      },
    );
    // console.log(
      // "LISTANDO FICHEROS GD: ",
      // {
        // token: userData.token,
        // seccion: section,
        // start,
        // total,
      // },
      // response,
    // );
    setList(response);
  }, [section, start, total]);

  useEffect(() => {
    getData();
  }, [getData]);

  return [list, getData];
}
